module.exports = __webpack_public_path__ + "img/pizza.57dd0be2.png";